var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-article__share-btns" }, [
    _c("div", { staticClass: "u-relative", attrs: { id: "vue-copyLink" } }, [
      _c(
        "a",
        {
          attrs: { href: "#", id: "linkCopy" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.copyLink.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: "/img/icons/icon-copy-link-article.svg",
              alt: "Copy Article Link",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-fading-message",
          class: { show: _vm.error },
          attrs: { id: "messageArea" },
          on: {
            click: function ($event) {
              _vm.error = false
            },
          },
        },
        [
          _c("div", [
            _c("img", {
              attrs: { src: "/img/ui/copy-link.svg", alt: "Copy link icon" },
            }),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.message))]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("The Community URL Link has been copied to your Clipboard."),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href:
            "mailto:?subject=" +
            encodeURI(_vm.shareSubject) +
            "&body=" +
            encodeURI(_vm.shareBody),
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/img/icons/icon-email-share-article.svg",
            alt: "Share Article via Email",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href:
            "https://www.facebook.com/sharer/sharer.php?u=" +
            encodeURI(_vm.selfUrl),
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/img/icons/icon-facebook-article.svg",
            alt: "Share Article via Facebook",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href:
            "https://twitter.com/intent/tweet?url=" +
            encodeURI(_vm.selfUrl) +
            "&text=" +
            encodeURI(_vm.shareText),
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/img/icons/icon-twitter-article.svg",
            alt: "Share Article via Twitter",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _vm.$simpleStore.isMobile
      ? _c(
          "a",
          {
            attrs: {
              href: "https://wa.me/?text=" + encodeURI(_vm.selfUrl),
              target: "_blank",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "/img/icons/icon-whatsapp-article.svg",
                alt: "Share Article via Whatsapp",
              },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }